import type { ReportField } from "../../../../../../../api/types/svTypes.ts";
import { getFieldCaption } from "../../../utilities/Utilities.tsx";

export interface BlankFieldSettings {
  hideBlank: boolean;
  hideZero: boolean;
  scope: "All" | "Selected";
  fieldIds: string[];
}

export interface ColumnOption {
  id: string;
  label: string;
}

export const getColumnOptions = (fields: ReportField[], ids: string[]): ColumnOption[] => {
  const idSet = new Set(ids);
  return fields
    .filter((field) => idSet.has(field.config.guid))
    .map((field) => ({ id: field.config.guid, label: getFieldCaption(field) }));
};

export const toggleHideBlankFields = (settings: BlankFieldSettings, hideBlank: boolean): BlankFieldSettings => ({
  ...settings,
  hideBlank,
  ...(hideBlank ? {} : { hideZero: false, scope: "All", fieldIds: [] }),
});
